import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Text } from '@chakra-ui/react';
import { QueryClient } from '@tanstack/react-query';
import { FIND_BOOKING, FIND_BOOKING_COOKIE_NAME_KEY, FIND_BOOKING_SOURCE_PMS } from '@whitbread-eos/api';
import { Error, Form, ModalVariants, Notification } from '@whitbread-eos/atoms';
import { cleanupFindBookingToken, graphQLRequest, isStringValid, setCookie, useCustomLocale } from '@whitbread-eos/utils';
import { format } from 'date-fns';
import { useCallback, useState } from 'react';
import { manageBookingFormConfig } from './manageBookingFormConfig';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ManageBookingModal(_ref) {
  var _labels$headerInforma5, _labels$headerInforma6;
  var labels = _ref.labels,
    onClose = _ref.onClose,
    isOpen = _ref.isOpen,
    baseTestId = _ref.baseTestId;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitDisabled = _useState2[0],
    setIsSubmitDisabled = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    resetForm = _useState4[0],
    setResetForm = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    findBookingError = _useState6[0],
    setFindBookingError = _useState6[1];
  var _useState7 = useState({
      bookingReference: '',
      bookingSurname: '',
      arrivalDate: new Date().toString()
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    defaultValues = _useState8[0],
    setDefaultValues = _useState8[1];
  var onFindBookingSuccess = (response, findBookingCriteria) => {
    if (!(response !== null && response !== void 0 && response.findBooking)) {
      return;
    }
    setIsSubmitDisabled(false);
    var _response$findBooking = response.findBooking,
      ref = _response$findBooking.ref,
      basketReference = _response$findBooking.basketReference,
      cookieName = _response$findBooking.cookieName,
      token = _response$findBooking.token,
      sourcePms = _response$findBooking.sourcePms,
      redirectBase = _response$findBooking.redirectBase,
      minutesTillExpiry = _response$findBooking.minutesTillExpiry,
      operaConfNumber = _response$findBooking.operaConfNumber;
    if (sourcePms === FIND_BOOKING_SOURCE_PMS.OPERA && ref && basketReference || sourcePms === FIND_BOOKING_SOURCE_PMS.BART && ref) {
      var cookieValue = sourcePms === FIND_BOOKING_SOURCE_PMS.OPERA ? {
        token,
        basketReference,
        bookingReference: ref,
        operaConfNumber: operaConfNumber !== null && operaConfNumber !== void 0 ? operaConfNumber : ''
      } : {
        arrivalDate: findBookingCriteria.arrivalDate,
        surname: findBookingCriteria.lastName
      };
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(FIND_BOOKING_COOKIE_NAME_KEY, cookieName !== null && cookieName !== void 0 ? cookieName : '');
      }
      setCookie(cookieName !== null && cookieName !== void 0 ? cookieName : '', window.btoa(JSON.stringify(cookieValue)), Number(minutesTillExpiry));
      if (isStringValid(redirectBase)) {
        window.location.href = "".concat(redirectBase, "?bookingReference=").concat(ref);
      }
      onCloseModal();
    } else {
      var _labels$headerInforma, _labels$headerInforma2;
      setFindBookingError((_labels$headerInforma = labels === null || labels === void 0 || (_labels$headerInforma2 = labels.headerInformation) === null || _labels$headerInforma2 === void 0 || (_labels$headerInforma2 = _labels$headerInforma2.form) === null || _labels$headerInforma2 === void 0 ? void 0 : _labels$headerInforma2.bookingInvalid) !== null && _labels$headerInforma !== void 0 ? _labels$headerInforma : '');
    }
  };
  var onFindBookingError = () => {
    var _labels$headerInforma3, _labels$headerInforma4;
    setIsSubmitDisabled(false);
    setFindBookingError((_labels$headerInforma3 = labels === null || labels === void 0 || (_labels$headerInforma4 = labels.headerInformation) === null || _labels$headerInforma4 === void 0 || (_labels$headerInforma4 = _labels$headerInforma4.form) === null || _labels$headerInforma4 === void 0 ? void 0 : _labels$headerInforma4.searchBookingError) !== null && _labels$headerInforma3 !== void 0 ? _labels$headerInforma3 : '');
  };
  var onSubmit = data => {
    cleanupFindBookingToken();
    var queryClient = new QueryClient();
    setIsSubmitDisabled(true);
    var findBookingCriteria = {
      country,
      language,
      arrivalDate: format(new Date(data.arrivalDate), 'yyyy-MM-dd'),
      lastName: data.bookingSurname,
      resNo: String(data.bookingReference).toUpperCase()
    };
    queryClient.fetchQuery({
      queryKey: ['FindBooking', findBookingCriteria.country, findBookingCriteria.language, findBookingCriteria.arrivalDate, findBookingCriteria.lastName, findBookingCriteria.resNo],
      queryFn: () => graphQLRequest(FIND_BOOKING, {
        findBookingCriteria
      })
    }).then(response => onFindBookingSuccess(response, findBookingCriteria)).catch(onFindBookingError);
  };
  var getFormState = useCallback(state => {
    setDefaultValues(state);
  }, [setDefaultValues]);
  var onCloseModal = () => {
    setResetForm(prev => prev + 1);
    setFindBookingError('');
    onClose();
  };
  return _jsx(ModalVariants, {
    isOpen: isOpen,
    onClose: onCloseModal,
    dataTestId: baseTestId,
    variant: "default",
    variantProps: {
      title: '',
      delimiter: true,
      overflowVisible: true,
      isCentered: false
    },
    children: _jsxs(Flex, _objectSpread(_objectSpread({}, wrapperStyles), {}, {
      children: [_jsx(Text, _objectSpread(_objectSpread({
        as: "h4"
      }, textStyles.title), {}, {
        "data-testid": "".concat(baseTestId, "_Title"),
        children: labels === null || labels === void 0 || (_labels$headerInforma5 = labels.headerInformation) === null || _labels$headerInforma5 === void 0 || (_labels$headerInforma5 = _labels$headerInforma5.form) === null || _labels$headerInforma5 === void 0 ? void 0 : _labels$headerInforma5.findBookingTitle
      })), _jsx(Text, _objectSpread(_objectSpread({
        as: "h6"
      }, textStyles.description), {}, {
        "data-testid": "".concat(baseTestId, "_Description"),
        mb: "xl",
        children: labels === null || labels === void 0 || (_labels$headerInforma6 = labels.headerInformation) === null || _labels$headerInforma6 === void 0 || (_labels$headerInforma6 = _labels$headerInforma6.form) === null || _labels$headerInforma6 === void 0 ? void 0 : _labels$headerInforma6.findBookingDescription
      })), isStringValid(findBookingError) && _jsx(Box, {
        mb: "xl",
        children: _jsx(Notification, {
          svg: _jsx(Error, {}),
          status: "error",
          description: findBookingError,
          variant: "error",
          "data-testid": "".concat(baseTestId, "-Error-Message"),
          maxW: "full"
        })
      }), _jsx(Form, _objectSpread({}, manageBookingFormConfig({
        getFormState,
        defaultValues,
        onSubmit,
        baseTestId,
        resetForm,
        labels,
        isSubmitDisabled
      })))]
    }))
  });
}
var textStyles = {
  title: {
    textAlign: 'center',
    fontWeight: 'semibold',
    fontSize: 'xl',
    lineHeight: '3'
  },
  description: {
    textAlign: 'center',
    pt: 'md',
    fontWeight: 'normal',
    fontSize: 'md',
    lineHeight: '3'
  }
};
var wrapperStyles = {
  alignItems: 'center',
  justifyContent: 'center',
  direction: 'column',
  width: {
    sm: '22.063rem',
    md: '21.75rem',
    lg: '24.5rem',
    xl: '26.25rem'
  },
  mt: 'lg',
  mb: 'md',
  mx: {
    mobile: 'md',
    sm: 'lg',
    md: '8xl'
  }
};